import {
    MANAGE_COMMENTS_TRACKER,
    MANAGE_DM_TRACKER,
    MANAGE_IMPORTANT_TRACKER,
    MANAGE_MENTIONS_TRACKER,
    MANAGE_RESOLVED_TRACKER
} from '@/lib/routes/privateRoutes';

export const MESSAGE_FILTER_META = {
    comment: {
        key: 'comment',
        icon: 'bubble-outline',
        activeIcon: 'bubble',
        url: MANAGE_COMMENTS_TRACKER
    },
    mention: {
        key: 'mention',
        icon: 'mentions',
        activeIcon: 'mentions',
        url: MANAGE_MENTIONS_TRACKER
    },
    dm: {
        key: 'dm',
        icon: 'dm',
        activeIcon: 'dm',
        url: MANAGE_DM_TRACKER
    },
    important: {
        key: 'important',
        icon: 'flag',
        activeIcon: 'flag',
        url: MANAGE_IMPORTANT_TRACKER,
        status: 'important'
    },
    resolved: {
        key: 'resolved',
        icon: 'check-circle-outline',
        activeIcon: 'check-circle',
        url: MANAGE_RESOLVED_TRACKER,
        status: 'resolved'
    }
} as const;

export const CONVERSATIONS_REFRESH_INTERVAL = 30000; // 30 sec

export const DEFAULT_SOCIAL_INBOX_TYPES = [
    MESSAGE_FILTER_META.comment.key,
    MESSAGE_FILTER_META.mention.key,
    MESSAGE_FILTER_META.dm.key
] as const;

export const SOCIAL_INBOX_MANAGING_OPTIONS = [
    MESSAGE_FILTER_META.important.key,
    MESSAGE_FILTER_META.resolved.key
] as const;

export const INSTAGRAM_ONLY_FEATURES = [
    MESSAGE_FILTER_META.dm.key,
    MESSAGE_FILTER_META.mention.key
] as const;

// TODO: Move labels to translate file and use the key to map it instead
// ex.: conversation.sort.newest = "Newest First"
export const SORT_OPTIONS = [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'unread', label: 'Unread First' }
] as const;

// TODO: Move labels to translate file and use the key to map it instead
// ex.: conversation.dm.filters.all = "All"
export const DM_FILTER_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: 'unread', label: 'Unread' },
    { value: 'read', label: 'Read' }
] as const;
